// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { MenuOutlined, CategoryOutlined, BurstModeOutlined, DoDisturbOutlined, EditNoteOutlined, Filter, AutoAwesomeMotionOutlined } from '@mui/icons-material';
import enums from 'utils/enums';

// icons
const icons = {
  MenuOutlined,
  CategoryOutlined,
  BurstModeOutlined,
  DoDisturbOutlined,
  EditNoteOutlined,
  Filter,
  AutoAwesomeMotionOutlined
};

// ==============================|| MENU ITEMS - MAIN ||============================== //
const mobileApplications = {
  id: 'mobile-application',
  type: 'group',
  title: <FormattedMessage id='application' />,
  roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.SiteManager, enums.userRole.User],
  children: [
    {
      id: 'disableditemlist',
      title: <FormattedMessage id='disabledlist' />,
      subTitle: 'Manage Disabled Items',
      type: 'item',
      url: 'mobile-application/disableditem',
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.SiteManager, enums.userRole.User],
      icon: icons.DoDisturbOutlined,
      isShowFilter: true,
      showTitle: true
    },
  ]
};

export default mobileApplications;
